/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetCompaniesCompanyIdAddressesSearchQueryResponse, GetCompaniesCompanyIdAddressesSearchPathParams, GetCompaniesCompanyIdAddressesSearchQueryParams, GetCompaniesCompanyIdAddressesSearch400 } from "../entities/GetCompaniesCompanyIdAddressesSearch";

function getGetCompaniesCompanyIdAddressesSearchUrl(company_id: GetCompaniesCompanyIdAddressesSearchPathParams["company_id"]) {
  const res = { method: 'GET', url: `/companies/${company_id}/addresses/search` as const }  
  return res
}

/**
 * @description Поиск адресов по названию
 * @summary Поиск адресов по названию
 * {@link /companies/:company_id/addresses/search}
 */
export async function getCompaniesCompanyIdAddressesSearch(company_id: GetCompaniesCompanyIdAddressesSearchPathParams["company_id"], params?: GetCompaniesCompanyIdAddressesSearchQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetCompaniesCompanyIdAddressesSearchQueryResponse, ResponseErrorConfig<GetCompaniesCompanyIdAddressesSearch400>, unknown>({ method : "GET", url : getGetCompaniesCompanyIdAddressesSearchUrl(company_id).url.toString(), params, ... requestConfig })  
  return res.data
}